import React from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { DialogProvider } from "./contexts/DialogContext";
import "./index.css";
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
    <AuthProvider>
      <DialogProvider>
        <BrowserRouter>
          <App />
          <Toaster
            position="bottom-center"
            toastOptions={{ style: { maxWidth: 600 } }}
          />
        </BrowserRouter>
      </DialogProvider>
    </AuthProvider>
);
